// extracted by mini-css-extract-plugin
export default {"productName":"product-view__productName___uUYs6","logo":"product-view__logo___z6Fhh","description":"product-view__description___ZPqSo"};